import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import NoDataCard from "../cards/NoDataCard";

export const AppSettingsTable = (props) => {
  const { data, onClickEdit } = props;
  const theme = useTheme();

  return (
    <Stack
      direction={"column"}
      sx={{ bgcolor: theme.palette.common.white, borderRadius: 3, p: 2 }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow sx={{ height: 70 }}>
              <TableCell sx={{ py: "12px" }}>
                <Typography variant="h2">Platform</Typography>
              </TableCell>
              <TableCell sx={{ py: 0 }}>
                <Typography variant="h2">Latest Version</Typography>
              </TableCell>

              <TableCell sx={{ py: 0 }} />
              <TableCell sx={{ py: 0 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((org, index) => {
              return (
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  key={index}
                >
                  <TableCell sx={{ py: "12px", width: "200px" }}>
                    <Typography variant="p1">
                      {org.device_os === "android" ? "Android" : "iOS"}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ py: 0, width: "200px" }}>
                    <Typography variant="p1">{org.version}</Typography>
                  </TableCell>
                  <TableCell align="left" sx={{ py: 0 }}>
                    {!org.is_superuser && (
                      <Button
                        color="theme"
                        onClick={() => onClickEdit(org)}
                        sx={{
                          fontSize: 14,
                          fontWeight: 400,
                          textTransform: "none",
                          width: "55px",
                        }}
                        disableElevation
                        size="small"
                      >
                        Edit
                      </Button>
                    )}
                  </TableCell>
                  <TableCell sx={{ py: 0 }} />
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {data.length === 0 && <NoDataCard title={"No Data Found"} />}
    </Stack>
  );
};
